import { ColorPicker } from 'browser/components/atomic-elements/atoms/input/color-picker'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
export const ColorPickerField = LabelFieldFactory({ InputComponent: ColorPicker })
